import { FieldRegistration, ContextProvider } from '../fieldRegistry';
import {
  extractMediaValue,
  createMediaUpdateHandler,
  resolveMediaPlaceholder,
  createMediaSerializer,
  createMediaStoreSerializer,
  validateMediaField
} from '../fieldUtils';
import { renderAudioField } from './audioFieldRenderer';

const provideAudioContext: ContextProvider = (field, cardItem) => {
  const originalAudio = (
    cardItem?.[field.name] as Array<{ id?: string | number }>
  )?.[0];
  return { initialAudioId: originalAudio?.id };
};

export const audioFieldConfig: FieldRegistration = {
  renderer: renderAudioField,
  extractor: extractMediaValue,
  updateHandler: createMediaUpdateHandler('audios'),
  placeholderResolver: resolveMediaPlaceholder('audio'),
  apiSerializer: createMediaSerializer('audio_ids'),
  storeSerializer: createMediaStoreSerializer(),
  contextProvider: provideAudioContext,
  validator: validateMediaField
};
